import {
	SET_PRESCRIPTIONS_FILTERS,
	RESET_PRESCRIPTIONS_FILTERS
} from '../actions/filterPrescriptions'

export const DEFAULT = {
	items: [],
	currentPage: 1,
	itemsPerPage: 10,
	totalPages: 1,
	especialidad: null,
	fechaDesde: null,
	fechaHasta: null,
	filtro: '',
	criterioOrden: null,
	orden: 'asc'
}

export const filterPrescriptionsReducer = (state = DEFAULT, action) => {
	switch (action.type) {
		case SET_PRESCRIPTIONS_FILTERS:
			return { ...action.payload }
		case RESET_PRESCRIPTIONS_FILTERS:
			return DEFAULT
		default:
			return state
	}
}

export const selectPrescriptionsFilters = filterPrescriptions => {
	return filterPrescriptions ?? DEFAULT
}

export const selectPrescriptionsFiltersCount = filterPrescriptions => {
	const f = selectPrescriptionsFilters(filterPrescriptions)
	let count = 0
	if (f.especialidad) count += 1
	if (f.fechaDesde || f.fechaHasta) count += 1
	if (f.filtro) count += 1
	return count
}
